export const GeneratedQuestionsList = [
    {
       question: "How do I ask my doctor for this?",
       
       icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
       <circle cx="8.66667" cy="5.99967" r="2.66667" stroke="#59748A"/>
       <ellipse cx="8.66667" cy="13.3337" rx="4.66667" ry="2.66667" stroke="#59748A"/>
       <path d="M14.6667 3.33301C14.6667 3.33301 16.0001 4.13301 16.0001 5.99967C16.0001 7.86634 14.6667 8.66634 14.6667 8.66634" stroke="#59748A" stroke-linecap="round"/>
       <path d="M13.3333 4.66699C13.3333 4.66699 13.9999 5.06699 13.9999 6.00033C13.9999 6.93366 13.3333 7.33366 13.3333 7.33366" stroke="#59748A" stroke-linecap="round"/>
       </svg>
        
    },
    {
        question: "What are my rights in asking for this test?"
    },
    {
        question: "Is this procedure intrusive?"
    },
    {
        question: "Why do I need this test?"
    }
    
];